import React from 'react'
import { Button, Container } from '@sencha/ext-modern'

export default ({ showMe }) => {
	return showMe && <Container
		left='calc(50% - 16px)'
		top='calc(50% - 16px)'
	>
		<Button ui='managerSpinner' /* hidden={!showMe} */
			iconCls='x-fa fa-spinner fa-spin'
			style={{ mixBlendMode: 'multiply' }}
		/>
	</Container> || null
}